export const HttpUtils = {
  isInformational: (status: number): boolean => status >= 100 && status <= 199,
  isSuccess: (status: number): boolean => status >= 200 && status <= 299,
  isRedirection: (status: number): boolean => status >= 300 && status <= 399,
  isClientError: (status: number): boolean => status >= 400 && status <= 499,
  isServerError: (status: number): boolean => status >= 500 && status <= 599,
};
